var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup__video-container"},[_c('div',{staticClass:"video__holder"},[_c('video',{staticClass:"popup__video",attrs:{"muted":"","loop":"","autoplay":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.video,"type":"video/mp4"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }